import React, { useEffect, useState } from 'react';
import {Redirect } from "react-router-dom";
import { useCoverLetter } from '../../context/CoverLetterContext';
import { 
  COVERLETTER_EXPERIENCE,
  COVERLETTER_SKILLS,
  COVERLETTER_JOBDETAILS,
  COVERLETTER_CUSTOMIZE,
  COVERLETTER_STRENGTH
} from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/on-bording-screens.scss';
import JobForm from './QuesAnsSections/JobForm';

const JobDetails = (props) => {
    const [back, setBack] = useState(false);
    const [next, setNext] = useState(false);
    const [redirect2, setRedirect2] = useState(null);
    const { 
      ques_ans_response,
      qa_steps_initiated,
    handlers: {
        saveQA,
        loadQA
    },
  } = useCoverLetter();

  const saveForm = (data) => {
    saveQA({ ques_ans_response: {...ques_ans_response, ...data} })
  }
  useEffect(() => {
    //browser issue, page not opening at top
    window.scrollTo(0, 0)
    loadQA()
  }, []);
  //Show error using this state
  const [error, setError] = useState({});
  const [checkField, setCheckField] = useState('');
  const removeError = (e) => {
    setError({ ...error, [e.target.name]: "" });
  }
  const fieldFocus = e => {
    setCheckField(e.target.name);
    removeError(e);
  }

  const fieldBlur = e => {
    setCheckField('');
  }
  useEffect(() => {
    (next || back) && history.pushState(null, COVERLETTER_JOBDETAILS);
    next && setRedirect2(ques_ans_response.desired_position.trim().length ? COVERLETTER_SKILLS : COVERLETTER_STRENGTH)
    back && setRedirect2(COVERLETTER_CUSTOMIZE)
  }, [back, next]);

  if (redirect2) return <Redirect to={redirect2} />

  return (
    <div className="cover-screen-outer big-screen-outer">
      <div className="screen-inner">
        <div className="block">
            <div className="progress-bar">
              <div className="bar-outer">
                  <div className="bar-inner"></div>
              </div>
              <div className="bar-levels">
                  <div className="level-text"><span className="level-mark"></span>Select a Template</div>
                  <div className="level-text active"><span className="level-mark"></span>Job Goals</div>
                  <div className="level-text"><span className="level-mark"></span>Work Info</div>
                  <div className="level-text"><span className="level-mark"></span>Finalize</div>
              </div>
            </div>
          <div className="screen screen-two">
            {/* //Duplicate screen start  */}
              <div className="screen-previous">
                <div className="previous-head">Previous Answer</div>
                <div className="previous-block">
                  <div className="previous-answer" onClick={() => setBack(!back)}>Are you applying for a specific job? 
                    <div className="job-title-label">{ ques_ans_response.job_details_provided ? 'Yes' : 'Not Yet'}</div>
                  </div>
                </div>
              </div>
              {/* //Duplicate screen start  */}
            <h1>What position are you applying for?</h1>
              <JobForm data={ques_ans_response} save={saveForm} />
            <div className="screen-action">
            <button className="round-btn" onClick={() => setBack(!back)}> <i className="arrow-bar-left"></i><span>Back</span></button>
            <button className="round-btn  active" onClick={() => setNext(!next)}><span>Next</span><i className="arrow-bar-right"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobDetails;